var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 2h-1.5v-.75H7.5V2h-3v-.75h-.75V2h-1.5a.752.752 0 00-.75.75v7.5c0 .413.338.75.75.75h7.5c.413 0 .75-.338.75-.75v-7.5A.752.752 0 009.75 2zm0 8.25h-7.5V5h7.5v5.25zm0-6h-7.5v-1.5h1.5v.75h.75v-.75h3v.75h.75v-.75h1.5v1.5z"
  })));
}
export default SvgEmptyCalendarIcon;